module.exports = __webpack_public_path__ + "assets/img/banner-frase-540.jpg";